import {useEffect, useState} from 'react';
import {Move} from './types';

interface GameSolutionProps {
    solution:  Array<Move> | null,
    gameStateChanged: boolean,
    gameSolved: () => void,
}

function GameSolution({ solution, gameStateChanged, gameSolved } : GameSolutionProps) {


    return (
        <>
            <h3>Game Solution </h3>
            {(solution == null) ? <div></div> : <div>({solution?.length} moves)</div>}
            <div className="solutionMoves">
            {(solution == null) 
                ? <div></div> 
                : solution.map((value, index) => 
                    <div className="solutionMove" key={index} data-invalid={gameStateChanged}>
                        <svg xmlns="http://www.w3.org/2000/svg" height="25" width="25" key={index}>
                                <circle cx="12" cy="12" r="12" fill={value.Token} />
                        </svg>
                        {value.From + " --> " + value.To}
                    </div>
                    )}
            </div>
        </>
  );
}

export default GameSolution;
